import { render, staticRenderFns } from "./I18nText.vue?vue&type=template&id=a91461ca&"
import script from "./I18nText.vue?vue&type=script&lang=js&"
export * from "./I18nText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports